import styled from "styled-components";

const Styled = styled.div`
    display: grid;
    position: relative;

    span {
        font-size: .8rem;
        color: #000a;
        grid-column: span 2;
        line-height: .6rem;
        padding: 8px 12px 4px;
        pointer-events: none;
        position: absolute;
    }

    input {
        background: #0000000a;
        border: none;
        border-radius: 3px;
        box-sizing: border-box;
        font-size: 1.2rem;
        padding: 28px 8px 6px;

        &::before {
            content: attr(name);
        }

        &:read-only {
            cursor: default;
        }
    }
`;

export default function LabeledInput(props) {
    const { disabled, label, onChange, value } = props;
    return (
        <Styled>
            <span>{ label }</span>
            <input
                disabled={ disabled }
                name={ label }
                onChange={ (event) => onChange?.(parseInt(event.target.value)) }
                readOnly={ !onChange }
                type="number"
                value={ value }
            />
        </Styled>
    );
}
